// Import axe-core accessibility testing engine
import axe from 'axe-core'
import { gettext } from './translation'
import { alertSuccess } from '../globals/alerts'

/**
 * run axe-core accessibility testing engine
 * https://github.com/dequelabs/axe-core
 */
export async function runAxe() {
	axe
		.run()
		.then((results) => {
			const violations = results.violations
			if (violations.length) {
				violations.forEach((violation) => {
					if (violation.id === 'color-contrast') {
						// skip color-contrast violations until high-contrast-mode is not availible
						return
					}
					const impact = violation.impact
					const axeMessage = `[AXE] ${impact} accessibility issue:`
					if (impact === 'critical' || impact === 'serious') {
						console.error(axeMessage, violation)
					} else {
						console.warn(axeMessage, violation)
					}
				})
			}
		})
		.catch((err) => {
			console.error('[AXE] Something bad happened:', err.message)
		})
}

/**
 * init listeners to run axe-core accessibility testing engine
 */
export function initAxeEventListeners() {
	// DEVTOOLS
	const axeToolbarOption = document.querySelector('#runAxeFromDevTools')
	if (axeToolbarOption) {
		// eslint-disable-next-line no-console
		console.info(
			'[AXE] The accessibility testing engine is available under "Developer Tools" in the top navigation bar, or as a shortcut with "Control + Shift + A"'
		)

		axeToolbarOption.addEventListener('click', async () => {
			await runAxe()
			alertSuccess(
				undefined,
				gettext('AXE Barrierefreiheitsprüfung abgeschlossen')
			)
		})
	}
}
